import { useMemo } from 'react';
import { getRejectionReasonsByProId, getRejectionReasonsByProduto } from '../utils/rejectionReasons';

interface UseRejectionReasonsParams {
  proId?: number;
  produtoNome?: string;
}

interface UseRejectionReasonsReturn {
  motivosPrincipais: string[];
  detalhesSugeridos: string[];
}

/**
 * Hook para resolver motivos de recusa baseado no produto
 * Prioriza busca por ID, com fallback para nome do produto
 */
export function useRejectionReasons({ 
  proId, 
  produtoNome 
}: UseRejectionReasonsParams): UseRejectionReasonsReturn {
  const motivosPrincipais = useMemo(() => {
    // Tentar buscar por ID primeiro
    if (proId) {
      const byId = getRejectionReasonsByProId(proId);
      if (byId?.motivos?.length) {
        return byId.motivos;
      }
    }
    
    // Fallback para busca por nome
    if (produtoNome) {
      const byName = getRejectionReasonsByProduto(produtoNome);
      if (byName?.motivos?.length) {
        return byName.motivos;
      }
    }
    
    // Fallback seguro: array vazio
    return [];
  }, [proId, produtoNome]);

  const detalhesSugeridos = useMemo(() => {
    // Tentar buscar por ID primeiro
    if (proId) {
      const byId = getRejectionReasonsByProId(proId);
      if (byId?.detalhesSugeridos?.length) {
        return byId.detalhesSugeridos;
      }
    }
    
    // Fallback para busca por nome
    if (produtoNome) {
      const byName = getRejectionReasonsByProduto(produtoNome);
      if (byName?.detalhesSugeridos?.length) {
        return byName.detalhesSugeridos;
      }
    }
    
    // Fallback seguro: array vazio
    return [];
  }, [proId, produtoNome]);

  return {
    motivosPrincipais,
    detalhesSugeridos
  };
}

